// extracted by css-extract-rspack-plugin
export default {"content":"tEam_oUS478OZQbi","fullViewportContent":"epib2fhIDS4NVKOI"};